import React from 'react';
import { Link } from 'react-router-dom';
import Pictogramme from './Pictogramme';

export default function CarteMachine({ machine }) {
  const visuel = machine.visuel || machine.image;
  const detoure = Boolean(machine.visuel);
  const enAttente = Boolean(machine.pictogramme) && !visuel;

  return (
    <article className="carte overflow-hidden flex flex-col group">
      <div
        className={`relative h-[250px] flex items-end justify-center overflow-hidden ${
          detoure || enAttente
            ? 'bg-gradient-to-b from-trame via-trame to-white px-3 pt-4'
            : 'bg-trame p-4 items-center'
        }`}
      >
        {(detoure || enAttente) && (
          <>
            {/* ligne de sol */}
            <span
              className="absolute bottom-[26px] left-0 right-0 h-px bg-nuit/10"
              aria-hidden="true"
            />
            {/* ombre portee au sol */}
            {detoure && (
              <span
                className="absolute bottom-[18px] left-1/2 -translate-x-1/2 w-[76%] h-[16px] rounded-[50%] bg-nuit/25 blur-[7px] transition-all duration-500 group-hover:w-[80%] group-hover:opacity-80"
                aria-hidden="true"
              />
            )}
          </>
        )}

        {enAttente ? (
          <>
            <Pictogramme
              nom={machine.pictogramme}
              classe="relative w-[80%] max-w-[230px] mb-[14px] opacity-70 transition-opacity duration-500 group-hover:opacity-90"
            />
            <span className="absolute top-3 right-3 font-cond uppercase tracking-[0.08em] text-[11.5px] text-beton bg-white/85 px-2 py-1 rounded-[2px]">
              Photo à venir
            </span>
          </>
        ) : (
          <img
            src={visuel}
            alt={`${machine.nom}, ${machine.type.toLowerCase()}`}
            loading="lazy"
            className={`relative object-contain transition-transform duration-500 ${
              detoure
                ? 'max-h-[218px] max-w-[104%] w-auto mb-[22px] group-hover:scale-[1.06] group-hover:-translate-y-1'
                : 'max-h-full max-w-full w-auto group-hover:scale-[1.03]'
            }`}
          />
        )}
      </div>

      <div className="p-6 flex flex-col flex-1">
        <h3 className="font-display uppercase text-[24px] text-nuit">{machine.nom}</h3>
        <p className="mt-1.5 font-cond uppercase font-semibold tracking-[0.05em] text-[15px] text-bleu">
          {machine.type}
        </p>
        <p className="mt-3 text-nuit/75 text-[16px] flex-1">{machine.accroche}</p>

        {machine.specs ? (
          <ul className="mt-4 space-y-1.5">
            {machine.specs.slice(0, 3).map(([k, v]) => (
              <li key={k} className="border-b border-nuit/10 pb-2">
                <span className="block font-cond uppercase tracking-[0.07em] text-[12.5px] text-beton">{k}</span>
                <span className="block font-semibold text-nuit text-[15.5px] leading-snug">{v}</span>
              </li>
            ))}
          </ul>
        ) : (
          <ul className="mt-4 space-y-1.5">
            {machine.pour.slice(0, 3).map((p) => (
              <li key={p} className="border-b border-nuit/10 pb-2 flex gap-2.5 items-start">
                <span className="mt-1.5 shrink-0 w-2 h-2 bg-bleu" aria-hidden="true" />
                <span className="text-nuit text-[15.5px] leading-snug">{p}</span>
              </li>
            ))}
          </ul>
        )}

        <Link to={`/nos-engins/${machine.slug}`} className="btn-ligne mt-6 w-full">
          {machine.specs ? 'Voir la fiche complète' : 'Voir les usages'}
        </Link>
      </div>
    </article>
  );
}
